import React, { lazy, useCallback } from 'react';
import ReactDom from 'react-dom';

import {
  AccountManager,
  QuickBetslipProvider,
  SiteConfigManager,
  useBetslipState,
} from '@atlas/core';
import { Label, MoneyInput } from '@atlas/ui';

import QuickBetInfo from 'common/Betslip/QuickBetInfo';

const IFrameQuickBetAgreeButton = lazy(
  () => import(/* webpackChunkName: "iframeC" */ 'iframe/IFrameQuickBetAgreeButton'),
);

export default function () {
  const isSimplifiedView = SiteConfigManager.getConfig(
    'config.config.sportsbook.mobileGridViewType',
  );
  return (
    <QuickBetslipProvider>
      <IFrameQuickBet />
      {ReactDom.createPortal(
        <QuickBetInfo />,
        isSimplifiedView === 'simplified'
          ? document.querySelector('.layout-iframe')
          : document.body,
      )}
    </QuickBetslipProvider>
  );
}

const IFrameQuickBet = () => {
  const [desiredAmount, setDesiredAmount] = React.useState();

  return (
    <div className="quick-bet-info">
      <div className="quick-bet-input-container">
        <Label
          className="sub-title-text"
          message="When activating the Quick Bet mode you automatically agree to odds changes"
        />
        <QuickBetMoneyInput desiredAmount={desiredAmount} onChange={setDesiredAmount} />
      </div>
      <IFrameQuickBetAgreeButton desiredAmount={desiredAmount} />
    </div>
  );
};

const QuickBetMoneyInput = ({ desiredAmount, onChange }) => {
  const { loading } = useBetslipState();

  const [active, setActive] = React.useState(false);
  const currency = AccountManager.getAccountCurrency();

  const onKeyUp = useCallback(({ currentTarget, which }) => {
    // 13 is enter
    if (which === 13) {
      currentTarget.blur();
    }
  }, []);

  return (
    <MoneyInput
      active={active}
      currency={currency}
      dataTestId="betslip-amount"
      disabled={loading}
      label="Amount"
      onBlur={() => setActive(false)}
      onChange={onChange}
      onFocus={() => setActive(true)}
      onKeyUp={onKeyUp}
      touched
      value={desiredAmount}
    />
  );
};
